import {
  TYPES_SET,
} from '../mutation-types';

import Vue from 'vue';
import store from 'store';

const state = {
  types: null,
};

const mutations = {
  [TYPES_SET] (state, types) {
    store.set('types', types);
    Vue.set(state, 'types', types);
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/types.js